import {
    AmountSeries,
    SupplierSeries,
    WorkingCapitalLiftResponse
} from '@lsq-frontend/remote-services/analytics-graphql/src/lib/utils/types';
import { ChartFilters, WorkingCapitalLift } from './chart-types';
import chartUtils, { categorySort, dateSort, mapCentsToDollars } from './chart-utils';
import { HighChartComponent } from '../lsq-high-charts';
import { format } from 'date-fns';
import { DateFormat } from '@lsq-frontend/common-ui';

const getWorkingCapitalLiftConfig = (data: WorkingCapitalLift) => {
    const abbrevi = chartUtils.getDataLabelAbbreviator();
    const chartConfig = {
        chart: {
            type: 'column',
            height: '600px'
        },
        title: {
            text: null
        },
        xAxis: {
            categories: data.categories,
            title: {
                text: null
            },
            labels: {
                style: chartUtils.getTextStyle()
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Avg. Working Capital Lift',
                style: chartUtils.getTextStyle()
            },
            labels: {
                style: chartUtils.getTextStyle()
            }
        },
        tooltip: {
            style: chartUtils.getTextStyle(),
            formatter: function (this: any) {
                const header = `<b>${this.x}</b><br/>`;
                const body =
                    'Avg. Working Capital Lift: <b>' +
                    chartUtils.abbreviatorFormatter(this.y) +
                    '</b>';
                return '<div>' + header + body + '</div>';
            }
        },
        plotOptions: {
            series: {
                groupPadding: 0.15,
                pointPadding: 0.001
            }
        },
        exporting: {
            enabled: false
        },
        colors: ['#008661'],
        series: [
            {
                name: 'Amount',
                showInLegend: false,
                data: data.capitalAmount.map(mapCentsToDollars),
                ...abbrevi
            }
        ]
    };
    return chartConfig;
};

export default getWorkingCapitalLiftConfig;

export const GetWorkingCapitalLiftSchema = (
    data: WorkingCapitalLiftResponse,
    filters: ChartFilters,
    context: HighChartComponent
) => {
    const sourceData = data.workingCapitalLift.filter(
        (supp: SupplierSeries) =>
            filters.suppliers.includes(supp.name) || filters.suppliers.length === 0
    );

    const categories = sourceData
        .sort(categorySort)[0]
        .amountSeries.sort(dateSort)
        .map((serie: AmountSeries) => format(serie.date, DateFormat.MonthNumberDashYear));

    let capitalAmount: number[] = [];
    for (const supp of sourceData) {
        for (let [indx, slot] of supp.amountSeries.sort(dateSort).entries()) {
            capitalAmount[indx] = (capitalAmount[indx] ?? 0) + slot.workingCapitalLift.cents;
        }
    }
    const suppliers = sourceData.map((supp: SupplierSeries) => supp.name).sort();
    if (!context.suppliers) {
        context.suppliers = suppliers;
    }
    const schema = getWorkingCapitalLiftConfig({
        capitalAmount,
        categories
    });
    return schema;
};
